<script type="text/javascript">

export default {
  aName: {},
  setAName: function(newName) {
    this.aName = newName;
  },
};
</script>
